import classnames from "classnames";
import React, { MouseEvent } from "react";
import { Button } from "reactstrap";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

type ShowMoreProps = {
    showMore: () => void;
    isShowingMore: boolean;
    className?: string;
};

const ShowMoreComponent = ({
    showMore,
    isShowingMore,
    className,
}: ShowMoreProps) => {
    const { t } = useGranite();

    const handleOnShowMoreClick = (event: MouseEvent) => {
        event.stopPropagation();
        event.target instanceof HTMLElement && event.target.blur();
        showMore();
    };

    return (
        <Button
            className={classnames("px-0 text-left", className)}
            color={"link"}
            onClick={handleOnShowMoreClick}
        >
            {isShowingMore ? (
                <>
                    <i className={"las la-angle-up mr-2"}></i>
                    {t("search.refinements.showLess")}
                </>
            ) : (
                <>
                    <i className={"las la-angle-down mr-2"}></i>
                    {t("search.refinements.showMore")}
                </>
            )}
        </Button>
    );
};

export { ShowMoreComponent };
